<script>
export default {
  name: 'CandidateListSkeleton',
}
</script>

<template>
  <div>
    <v-skeleton-loader
      v-for="i of 16"
      :key="`candidate-list-skeleton-index--${i}`"
      type="list-item-avatar-three-line"
    ></v-skeleton-loader>
  </div>
</template>
